// src/components/Sidebar.js
import React, { useState,useEffect } from "react";
import { Link, Links, useNavigate, useParams } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { useSidebar } from "../../contexts/SidebarContext";


const Sidebar = () => {
  const userToken = localStorage.getItem("userToken");
  const history = useNavigate();
  const { isSidebarToggled, toggleSidebar } = useSidebar();

  const logout = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("email");
    localStorage.clear();
    toast.success("You are logged out");
    history("/");
  };

  useEffect(() => {
    // Toggle sidebar class on body
    document.body.classList.toggle("toggle-sidebar", isSidebarToggled);
  
    // Initialize Bootstrap Collapse components (not Dropdown)
    const collapseElements = document.querySelectorAll('[data-bs-toggle="collapse"]');
    collapseElements.forEach((element) => {
      new window.bootstrap.Collapse(element, {
        toggle: false // Optional configuration
      });
    });
  
    // If you actually need Dropdowns, use separate selector:
    const dropdownElements = document.querySelectorAll('.dropdown-toggle');
    dropdownElements.forEach((dropdown) => {
      new window.bootstrap.Dropdown(dropdown);
    });
  
    return () => {
      document.body.classList.remove("toggle-sidebar");
      // Cleanup collapse instances if needed
      collapseElements.forEach((element) => {
        const collapseInstance = window.bootstrap.Collapse.getInstance(element);
        if (collapseInstance) {
          collapseInstance.dispose();
        }
      });
    };
  }, [isSidebarToggled]);

  return (
    <aside id="sidebar" className={`sidebar ${isSidebarToggled ? 'toggled' : ''}`}>
      <ul className="sidebar-nav" id="sidebar-nav">
        {/* Toggle Button */}
        <li className="nav-item text-end d-block d-md-none">
          <button className="btn btn-link toggle-sidebar-btn" onClick={toggleSidebar}>
            <i className="bi bi-x-lg"></i>
          </button>
        </li>
          <>

            <li className="nav-item">
              <Link className="nav-link" to="/dashboard">
                <i className="bi bi-grid"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/admin/categories" className="nav-link">
                <i className="bi bi-people"></i>
                <span className="nav-text">Categories</span>
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/admin/packages" className="nav-link">
                <i className="bi bi-people"></i>
                <span className="nav-text">Package Demands</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/admin/tutors" className="nav-link">
                <i className="bi bi-people"></i>
                <span className="nav-text">Tutors</span>
              </Link>
            </li>
          
            <li className="nav-item">
              <Link to="/admin/questions" className="nav-link">
                <i className="bi bi-file"></i>
                <span className="nav-text">Uplaod PDF</span>
              </Link>
            </li>
            <li className="nav-item">
              <button onClick={logout} className="nav-link btn btn-sm">
                <FaSignOutAlt className="me-2" /> 
                <span className="nav-text">Logout</span>
              </button>
            </li>
            
          </>
        

        
      </ul>
    </aside>
  );
};

export default Sidebar;